import React, { useEffect, useState } from "react";

const QuoteDetails = ({ prevStep, handleChange, handleSubmit, formData }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const requiredFields = ["reel", "story", "post"];

  const validateForm = () => {
    return requiredFields.every((field) => {
      const value = formData[field];
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      return value !== null && value !== undefined;
    });
  };

  useEffect(() => {
    setIsButtonDisabled(!validateForm());
  }, [formData]);

  return (
    <form>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Quote For One Story
            </label>
            <input
              type="number"
              className="form-control"
              name="story"
              value={formData.story || ""}
              onChange={handleChange}
              id="exampleFormControlInput1"
              placeholder="Quote For One Story*"
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput2" className="form-label">
              Quote For One Reel
            </label>
            <input
              type="number"
              className="form-control"
              name="reel"
              value={formData.reel || ""}
              onChange={handleChange}
              id="exampleFormControlInput2"
              placeholder="Quote For One Reel*"
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput3" className="form-label">
              Quote For One Post
            </label>
            <input
              type="number"
              className="form-control"
              name="post"
              value={formData.post || ""}
              onChange={handleChange}
              id="exampleFormControlInput3"
              placeholder="Quote For One Post*"
              required
            />
          </div>
        </div>
      </div>
      <button className="prevBtn mt-3 me-2" onClick={prevStep}>
        Previous
      </button>
      <button
        type="submit"
        className="nextBtn mt-3"
        onClick={handleSubmit}
        disabled={isButtonDisabled}
      >
        Submit
      </button>
    </form>
  );
};

export default QuoteDetails;
